import React, { useEffect } from 'react';

import {useFormik} from "formik";
import * as yup from 'yup';

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";

import {DynamicFields} from "../../utils/dynamicFields";

import {Dialog} from "../Dialog/Dialog";

import {FillerSection} from "../FillerSection/FillerSection";
import {FullNameSelectFiller} from "./fillers/FullNameSelectFiller";
import {DateTimeSelectFiller} from "./fillers/DateTimeSelectFiller";
import {BaseSelectFiller} from "./fillers/BaseSelectFiller";
import {AutocompleteSelectFiller} from "./fillers/AutocompleteSelectFiller";
import {SelectOffenceListFiller} from "./fillers/SelectOffenceListFiller";
import {FreeAutocompleteSelectFiller} from "./fillers/FreeAutocompleteSelectFiller";
import { CheckListFiller } from './fillers/CheckListFiller';
import { TableConstructorFieldFiller } from '../TableConstructorField/TableConstructorFieldFiller/TableConstructorFieldFiller';
import { ChartFieldConstructorFiller } from '../ChartFieldConstructor/ChartFieldConstructorFiller/ChartFieldConstructorFiller';


const fieldTemplateDialogConfig = {
    [DynamicFields.TEXT_FIELD]: null,
    [DynamicFields.MULTILINE_TEXT_FIELD]: null,
    [DynamicFields.NUMBER_FIELD]: null,
    [DynamicFields.QR_CODE_FIELD]: null,
    [DynamicFields.QR_CODE_VIOLATION]: null,
    [DynamicFields.SIGNATURE_FIELD]: null,
    [DynamicFields.SIGNATURE_FOR_TABLE]: null,
    [DynamicFields.TABLE_DATE]: null,
    [DynamicFields.TABLE_DATE_TIME]: null,
    [DynamicFields.DATE_TIME_SELECT]: (props) => <DateTimeSelectFiller {...props}/>,
    [DynamicFields.BASE_SELECT]: (props) => <BaseSelectFiller {...props}/>,
    [DynamicFields.AUTOCOMPLETE_SELECT]: (props) => <AutocompleteSelectFiller {...props}/>,
    [DynamicFields.FREE_AUTOCOMPLETE_SELECT]: (props) => <FreeAutocompleteSelectFiller {...props}/>,
    [DynamicFields.FULL_NAME_FIELD]: (props) => <FullNameSelectFiller {...props}/>,
    [DynamicFields.NORMATIVE_ARTICLES_TABLE]: null,
    [DynamicFields.SELECTED_OFFENSE_LIST]: (props) => <SelectOffenceListFiller {...props}/>,
    [DynamicFields.CHECK_LIST]: (props) => <CheckListFiller {...props}/>,
    [DynamicFields.TABLE_CONSTRUCTOR]: (props) => <TableConstructorFieldFiller {...props}/>,
    [DynamicFields.CHART_CONSTRUCTOR]: (props) => <ChartFieldConstructorFiller {...props}/>,
}

const defaultFieldTemplate = {
    type: '',
    label: '',
    helperText: '',
    variable: '',
    widthFieldXs: 12,
    content: {
        required: true
    }
}

const fieldTemplateValidationSchema = yup.object().shape({
    type: yup.string().required('Необходимо заполнить'),
    label: yup.string().trim('Использование пробелов в конце запрещено').strict(true).required('Необходимо заполнить'),
    variable: yup.string()
        .trim('Использование пробелов в конце запрещено')
        .strict(true)
        .matches(/^[^\s()-]*$/, "Невозможно использовать пробелы, скобки и тире")
        .required('Необходимо заполнить'),
})


export const AddFieldTemplateDialog = ({open, handleClose, handleSave, selectedFieldTemplate, handleFieldTemplateChange}) => {
    const {values, touched, errors, getFieldProps, setFieldValue, handleSubmit} = useFormik({
        initialValues: selectedFieldTemplate || defaultFieldTemplate,
        validationSchema: fieldTemplateValidationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            selectedFieldTemplate ? handleFieldTemplateChange(values) : handleSave(values)
        }
    })

    useEffect(() => {

    }, [values])

    const {onChange: onChangeType, ...otherTypeFieldProps} = getFieldProps('type')
    const {value: required, ...otherRequiredFieldProps} = getFieldProps('content.required')

    const handleTypeFieldChange = (event) => {
        onChangeType(event)
        setFieldValue('content', defaultFieldTemplate.content)
    }

    return <Dialog open={open}
                   handleClose={handleClose}
                   title={'Добавление элемента'}
                   actions={<Button onClick={() => handleSubmit()}>Сохранить</Button>}
                   fullWidth
                   maxWidth={'lg'}
    >
        <Grid container direction={'column'} spacing={1}>
            <FillerSection title={'Основная информация'}>
                <Grid item container spacing={2}>
                    <Grid xs={4} item>
                        <TextField onChange={handleTypeFieldChange}
                                   label={'Тип элемента'}
                                   variant={'outlined'}
                                   size={'small'}
                                   error={touched.type && Boolean(errors.type)}
                                   helperText={errors.type && touched.type ? errors.type : ''}
                                   select
                                   fullWidth
                                   required
                                   {...otherTypeFieldProps}
                        >
                            {Object.values(DynamicFields).map(el => <MenuItem key={`field-template-type-${el}`}
                                                                              value={el}>
                                {el}
                            </MenuItem>)}
                        </TextField>
                    </Grid>
                    <Grid xs={4} item>
                        <TextField label={'Имя поля'}
                                   variant={'outlined'}
                                   size={'small'}
                                   error={touched.label && Boolean(errors.label)}
                                   helperText={errors.label && touched.label ? errors.label : ''}
                                   fullWidth
                                   {...getFieldProps('label')}
                        />
                    </Grid>
                    <Grid xs={4} item>
                        <TextField label={'Подсказка'}
                                   variant={'outlined'}
                                   size={'small'}
                                   fullWidth
                                   {...getFieldProps('helperText')}
                        />
                    </Grid>
                    <Grid xs={4} item>
                        <TextField label={'Переменная в Word шаблоне'}
                                   variant={'outlined'}
                                   size={'small'}
                                   error={touched.variable && Boolean(errors.variable)}
                                   helperText={errors.variable && touched.variable ? errors.variable : ''}
                                   fullWidth
                                   {...getFieldProps('variable')}
                        />
                    </Grid>
                    <Grid xs={4} item>
                        <TextField label={'размер блока'}
                                   variant={'outlined'}
                                   size={'small'}
                                   type='number'
                                   error={touched.variable && Boolean(errors.variable)}
                                   helperText={errors.variable && touched.variable ? errors.variable : ''}
                                   fullWidth
                                   {...getFieldProps('widthFieldXs')}
                        />
                    </Grid>
                    <Grid xs={4} item container alignItems={"center"}>
                        <Grid item>
                            <Checkbox label={'Переменная в Word шаблоне'}
                                      checked={required}
                                      {...otherRequiredFieldProps}
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant={'body1'}>Обязательное</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </FillerSection>
            {fieldTemplateDialogConfig[values.type]?.call(null, {
                setFieldValue,
                getFieldProps,
                content: values.content
            })}
        </Grid>
    </Dialog>
}